const lienPayement = {
  FR: '/secure/fr',
  IT: '/secure/it',
  ES: '/secure/es',
  EN: '/secure/en',
};

export default lienPayement;
